import { useState } from 'react';
import { Button, Col, Row, Container } from 'react-bootstrap';
import TableSearchModal from 'components/gifts-table/TableSearchModal';
// import homeBackground from 'assets/img/home.png';
// import iconoRegalo from 'assets/img/iconregalo_menu.svg';
// import logoSears from 'assets/img/logo_sears.png';
import { Modal } from 'components';
import TableSearchModalHome from 'components/gifts-table/TableSearchModalHome';
import { setLoginRedirectSSO } from 'util/navigation';
import { useIsMobile } from 'pages/Header/Content/hooks/useIsMobile';
import { wapLink } from '../../../constants/Wap/index';
// eslint-disable-next-line no-unused-vars
import HomeActionItem from './HomeActionItem';
import './style.scss';

export default function HeroSection({ isLoggedIn, setLoginRedirect }) {
  const [showSearch, setShowSearch] = useState(false);
  const [showModalGiftTable, setModalGiftTable] = useState(false);
  const {isMobile} = useIsMobile()

  const date = new Date()

  const homeBackground = `https://resources.sears.com.mx/medios-plazavip/swift/v1/mesaRegalos/mesa-original-v1.jpeg?ttl=${date.getFullYear()}${date.getMonth()}${date.getDate()}`

  const handleClickSearch = () => {
    setShowSearch(true);
  };

  function openTableDigital() {
    setLoginRedirect('mis-mesas', true, isLoggedIn);
  }

  function handleOpenModal() {
    setModalGiftTable(true);
  }

  function handleCloseModal() {
    setModalGiftTable(false);
  }

  return (
    <>
      <Modal
        title="¿En dónde abriste tu mesa de regalos?"
        titleClassName="text-center"
        show={showModalGiftTable}
        onClose={handleCloseModal}
        withActionButtons={false}
      >
        <div className="ContainerModal">
          <div>
            <Button block variant="primary">
              <a href={wapLink} className="Anchor">
                Abrí mi mesa en tienda
              </a>
            </Button>
            <span className="text-center d-block SpanModal">
              *Fui a mi tienda Sears y abrí mi mesa con un asesor en la tienda
            </span>
          </div>

          <div className="mt-5">
            <Button
              outline
              block
              variant="secondary"
              onClick={openTableDigital}
            >
              Abrí mi mesa en digital
            </Button>
            <span className="text-center d-block SpanModal">
              *Abrí mi mesa digital desde el sitio web de Sears
            </span>
          </div>
        </div>
      </Modal>
      <section className="HeroSection">
        {/* <div
            className="HeroSection__title"
            style={{ backgroundImage: `url(${homeBackground})` }}
        >
          <h1 className="title mt-3 principal-hero">
            Festeja cualquier ocasión con la nueva mesa de Regalos
            <img src={logoSears} alt="Logo Sears" className='logo-hero'/>
          </h1>
          <div className='buttons-container'>
            <a className="link-button" href={setLoginRedirectSSO('crear-mesa', true, isLoggedIn, true)}>
              <Button block variant="primary">
                Crear mi mesa de regalos
              </Button>
            </a>
            <a className="link-button" href="https://www.sears.com.mx/c/historias/" target="_blank" rel="noopener noreferrer">
              <Button block variant="secondary">
                <b>Gana Hasta $150,000 en monedero</b>
              </Button>
            </a>
          </div>
        </div>
        
        <div className="convierte">
          <i className="fa fa-gift fa-1x" />   CONVIERTE<span className="textoconvirte">TUS REGALOS</span>EN DINERO ELECTRÓNICO
        </div>
        */}

        <div
            className="NewSectionTitle"
            style={{ backgroundImage: `url(${homeBackground})` }}
        >

          <div className='contBtnsMesa'>
            <a className="link-button" href={setLoginRedirectSSO('crear-mesa', true, isLoggedIn, true)}>
              <Button block variant="primary" className="primaryButton">
                Crear mesa de regalos
              </Button>
            </a>
            <a className="link-button" href='/Mesa-de-Regalos/buscar-evento'>
              <Button block variant="secondary" className="secondaryButton">
                Buscar mesa de regalos
              </Button>
            </a>

            <a className="link-button" href={setLoginRedirectSSO('my-table', true, isLoggedIn, true)}>
              <Button block variant="linkBtn" className="thirdButton linkBtn">
                ¿Eres el festejado?
                <span>Entrar a mi mesa</span>
              </Button>
            </a>

          </div>
        </div>
        <div className="logoMesaBar" />


        <div>
          <TableSearchModalHome
              show={showSearch}
              onClose={() => setShowSearch(false)}
          />
        </div>


        {/* <div className=" pb-md-0">
          <Container className="p-0">
            <Row className="p-0 m-0">
              {
                isMobile === 'desktop' && <Col xs={12} sm={1} className="mb-3 mb-sm-0" />
              }
              <Col xs={12} sm={7} className="mb-3 mb-sm-0 create-table-container">
                <a className="link-button mb-2 d-inline-block" href={setLoginRedirectSSO('crear-mesa', true, isLoggedIn, true)}>
                  <Button block variant="primary">
                    Crear mi mesa de regalos
                  </Button>
                </a>
              </Col>
              <Col xs={12} sm={3} className="mb-sm-0 link-container">
                <strong>¿Ya tienes mesa?</strong>
                <a className="link-button mb-3 d-inline-block" href={setLoginRedirectSSO('my-tablebypass', true, isLoggedIn, true)}><u className='link'>Ingresar a mi mesa</u></a>
              </Col>
              <Col xs={12} sm={1} className="mb-3 mb-sm-0" />
            </Row>
          </Container>
        </div> */}


        {showSearch && (
            <TableSearchModal
                show={showSearch}
                onClose={() => setShowSearch(false)}
            />
        )}
      </section>
    </>
  );
}
